import { useEffect, useRef, useState } from 'react';
import './marquee.css';

interface MarqueeProps {
  width?: number;
  speed?: number; // 秒
  children: React.ReactNode;
}

export default function Marquee({ width = 70, speed = 8, children }: MarqueeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLSpanElement>(null);
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const container = containerRef.current;
      const content = contentRef.current;
      if (container && content) {
        console.log(content.scrollWidth, container.clientWidth, content.scrollWidth > container.clientWidth);
        setScrolling(content.scrollWidth > container.clientWidth);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [children]);

  return (
    <div ref={containerRef} className={`marquee ${scrolling ? 'is-scrolling' : ''}`} style={{ width }}>
      <div className="marquee__inner" style={{ animationDuration: `${speed}s` }}>
        <span ref={contentRef} className="marquee__content">
          {children}
        </span>
        {scrolling && <span className="marquee__content2">{children}</span>}
      </div>
    </div>
  );
}
